import { render, staticRenderFns } from "./CadastrarCompraAcessor.vue?vue&type=template&id=e2fb6e58&scoped=true&"
import script from "./CadastrarCompraAcessor.vue?vue&type=script&lang=js&"
export * from "./CadastrarCompraAcessor.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarCompraAcessor.vue?vue&type=style&index=0&id=e2fb6e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fb6e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
